<template>
    <CustomTopSheetDialog v-model="show" :width="1200" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('shop.profile.businessInfoDialog.title') }}
            </h3>
            <!-- <v-divider></v-divider> -->
        </template>

        <template #default>
            <v-form ref="form">

                <v-row class="shop-info-container">
                    <v-col cols="12" md="6">
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.name') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.name" variant="outlined" density="compact"
                                    :hide-details="true" :rules="nameRules">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4 mb-3">{{ $t('global.form.tagline') }}</v-label>
                            </v-col>
                            <v-col class="align-items-center text-right">
                                <!-- <span>noch {{ remainingCharacters }} </span> -->
                                <v-text-field ref="inputRef" v-model="shop.tagline" variant="outlined" density="compact"
                                    :hide-details="true" @focus="updateCursorPosition" @click="updateCursorPosition"
                                    @input="updateCursorPosition" @keyup="updateCursorPosition">
                                    <template v-slot:append-inner>
                                            <v-menu :close-on-content-click="false">
                                        <template v-slot:activator="{ props }">
                                            <v-btn size="x-small" color="default" variant="flat" v-bind="props"
                                                :icon="'mdi-emoticon-outline'">

                                            </v-btn>
                                        </template>
                                        <EmojiPicker @select="insertEmoji" />
                                    </v-menu>
                                    </template>
                                </v-text-field>
                                <!-- <EmojiPicker v-model="shop.tagline" @select="onChangeText" /> -->
                                <!-- <CustomEmojiPicker></CustomEmojiPicker> -->
                                
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.email') }}</v-label>
                            </v-col>
                            <v-col class="align-items-center text-right">
                                <!-- <span>noch {{ remainingCharacters }} </span> -->
                                <v-text-field v-model="shop.email" variant="outlined" density="compact"
                                    :hide-details="true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.facebook') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.facebookUrl" variant="outlined" density="compact"
                                    :hide-details="true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.instagram') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.instagramUrl" variant="outlined" density="compact"
                                    :hide-details="true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.homepage') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.homepage" variant="outlined" density="compact"
                                    :hide-details="true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.streetAndNumber') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.street" variant="outlined" density="compact"
                                    :hide-details="true" :rules="streetRules">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.addition1') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.addition1" variant="outlined" density="compact"
                                    :hide-details="true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.district') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">

                                <v-select v-model="shop.district" variant="outlined" density="compact"
                                    :hide-details="true" item-title="name" item-value="name"
                                    :items="filteredDisctricts">
                                    <template v-slot:selection="{ item }">
                                        {{ item.value == "" ? "Anderer Stadtteil" : item.value }}
                                    </template>
                                    <template v-slot:item="{ item, props }">
                                        <v-list-item v-bind="props">
                                            <template #title>
                                                <span>{{ item.value == "" ? "Anderer Stadtteil" : item.value }}</span>
                                            </template>
                                        </v-list-item>
                                    </template>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.postCode') }}</v-label>
                            </v-col>
                            <v-col sm="2" class="d-inline-flex align-items-center pr-0">
                                <v-text-field v-model="shop.postCode" variant="outlined" density="compact"
                                    :hide-details="true" :rules="postcodeRules">
                                </v-text-field>
                            </v-col>
                            <v-col sm="2" class="text-center">
                                <v-label class="mr-4">{{ $t('global.form.city') }}</v-label>
                            </v-col>
                            <v-col sm="4" class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.city" variant="outlined" density="compact"
                                    :hide-details="true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.phoneNumber') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.phoneNumber" variant="outlined" density="compact"
                                    :hide-details="true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.onlineshop') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.onlineShopUrl" variant="outlined" density="compact"
                                    :hide-details="true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="">
                            <v-col cols="3" sm="4" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.imprintUrl') }}</v-label>
                            </v-col>
                            <v-col class="d-inline-flex align-items-center">
                                <v-text-field v-model="shop.imprintUrl" variant="outlined" density="compact"
                                    :hide-details="true" :rules="urlRules">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6"> 
                        <v-row justify="center" align="center" class="">
                            <v-col sm="12" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.description') }}</v-label>
                            </v-col>
                            <v-col sm="12" class="align-items-center pl-0">
                                <v-textarea v-model="shop.description" class="shop-description-input" no-resize
                                    :hide-details="true" density="compact" variant="outlined" rows="6">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-row justify="center" align="center" class="">
                            <v-col sm="12" class="px-0">
                                <v-label class="mr-4">{{ $t('global.form.imprintText') }}</v-label>
                            </v-col>
                            <v-col sm="12" class="align-items-center pl-0">
                                <v-textarea v-model="shop.imprintText" class="shop-description-input" no-resize
                                    :hide-details="true" density="compact" variant="outlined" rows="6" :rules="textRules">
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-col>
                    
                </v-row>


                <v-row justify="center" class="">
                </v-row>
            </v-form>

        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="() => closeSheet(true)">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="large" prepend-icon="mdi-content-save"
                    color="primary" @click="validate">{{ $t('entity.action.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>

    <ConfirmCancelDialog v-model="showCancelDialog" @confirm-cancel="cancelChanges"></ConfirmCancelDialog>
</template>


<script>
import EmojiPicker from 'vue3-emoji-picker';
import 'vue3-emoji-picker/css'
import ConfirmCancelDialog from './ConfirmCancelDialog.vue';
export default {
    name: "EditShopInfoDialog",
    components: {
        EmojiPicker,
        ConfirmCancelDialog
    },
    // props: {
    //     modelValue: {
    //         type: Boolean,
    //         required: true,
    //     },
    // },
    // computed: {
    //     show: {
    //         get() {
    //             return this.modelValue;
    //         },
    //         set(value) {
    //             this.$emit("update:modelValue", value);
    //         },
    //     },


    // },

    methods: {
        // closeSheet() {
        //     this.show = false;
        // },

    },
};
</script>
<script setup>
import { ref, inject, onMounted, computed, watch, defineModel, getCurrentInstance } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import CustomEmojiPicker from '@/components/custom/CustomEmojiPicker.vue';

const originalShop = inject('shop');
const fetchOwnShop = inject('fetchOwnShop');
const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const softToken = localStorage.getItem("softToken");
const { proxy } = getCurrentInstance();
const form = ref(null);
const showCancelDialog = ref(false)
// const  = ref(Object.assign({}, orignalShop.value));
const shop = ref({ ...originalShop.value });
const areas = inject('areas');
const filteredDisctricts = computed(() => {
    console.log(shop.value.areaIds)
    console.log(areas.value["2ed6b621-1226-4d8d-819c-ed743be656d3"])
    console.log(typeof areas.value)
    const districts = areas.value
        .filter(item => shop.value.areaIds.includes(item.id))
        .flatMap(item => item.districtData || []);

    return [{ id: null, name: "" }, ...Object.values(districts[0])];
});
const show = defineModel();

const closeSheet = (byUser = false) => {

    if (byUser && JSON.stringify(originalShop.value) !== JSON.stringify(shop.value)) {
        console.log("show Verwerfen");
        showCancelDialog.value = true;
    }else{
        show.value = false;
    }
};

const cancelChanges = () =>{
    showCancelDialog.value = false;
    show.value = false;
    shop.value = { ...originalShop.value };
}




watch(() => originalShop.value, (newShop) => {
    shop.value = { ...newShop }; // Create a fresh copy when the original shop changes
}, { deep: true });

const maxLength = 30;
// const remainingCharacters = ref(maxLength - shop.value.email);

// Watch the tagline value to calculate remaining characters
// watch(() => shop.value.tagline, (newValue) => {
//     console.log('newValue', newValue.length)
//     remainingCharacters.value = maxLength - newValue.length;
// },{ immediate: true });
// const shop = computed(() => {
//     let obj= Object.assign({}, orignalShop.value);
//     return ref(obj);
// });

// var copy = Object.assign({}, orignalShop.value)
// const shop = ref(copy)

const insertEmoji = (emoji) => {
    const text = shop.value.tagline;
    const position = cursorPosition.value;
    shop.value.tagline = text.slice(0, position) + emoji.i + text.slice(position);
    cursorPosition.value += emoji.length; // Move the cursor forward
};

const sortOrderRules = [
    v => !!v || 'sortOrder is required',
    v => (v && v.toString().length >= 1) || 'sortOrder must be at least 1 digit.',
    v => (!isNaN(v)) || 'assetIdentifier must be numbers.',
];
const postcodeRules = [
    v => !!v || 'Postcode is required',
    v => (v && v.length >= 3) || 'assetIdentifier must be at least 3 characters.',
];

const nameRules = [
    v => !!v || 'Name is required',
    v => (v && v.length >= 3) || 'Name must be at least 3 characters',
];

const urlOrTextRule = [
  v => {
    if (shop.value.imprintUrl || shop.value.imprintText) {
      return true;
    }
    return 'Either URL or Text is required';
  },
  v => !v || /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([/\w .-]*)*\/?$/.test(v) || 'Please enter a valid URL',
];

const hasEither = () =>
  Boolean(shop.value.imprintUrl?.trim()) || Boolean(shop.value.imprintText?.trim());

const urlRules = [
  v => hasEither() || 'Either URL or Text is required',
  v => !v || /^(https?:\/\/)?(www\.)?[a-zA-Z0-9@:%._+~#=-]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/.test(v) || 'Please enter a valid URL',
];

const textRules = [
  v => hasEither() || 'Either URL or Text is required',
];

const streetRules = [
    v => !!v || 'Street and Nr is required',
    v => (v && v.toString().length >= 1) || 'App ID must be at least 1 digit.',
]

const validate = async () => {
    const { valid, errors } = await form.value.validate()
    if (!valid) {
        let errorMessages = [];
        Object.values(errors).forEach(fieldErrors => {
            if (fieldErrors.errorMessages.length) {
                errorMessages.push(...fieldErrors.errorMessages);
            }
        });
        errorMessages.forEach(msg => {
            if (msg.length) {
                proxy.$toast.error(msg, { theme: "colored" });
            }
        })
         
        return;
    }
    save();
}

const save = async () => {

    try {
        const response = await proxy.$axios.post("/shop", shop.value, {
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });
        console.log("response", response)
        if (response.status == 200) {
            closeSheet();
        }
    } catch (error) {
        console.error("Error fetching search results:", error);
    } finally {
        fetchOwnShop();

    }
}


const cursorPosition = ref(0); // Track cursor position
const inputRef = ref(null);

const updateCursorPosition = (event) => {
    const target = event.target || inputRef.value?.$el.querySelector("input");
    if (target) {
        cursorPosition.value = target.selectionStart;
        console.log("Cursor position updated:", cursorPosition.value);
    }
};

onMounted(() => {
    console.log("Input reference:", inputRef.value);
});


</script>

<style>
.v-field--appended {
    padding-inline-end: 0px !important;
}

@media only screen and (max-width: 960px) {
    .v-col-3>.v-label {
        font-weight: 700;
        font-size: 12px;
        white-space: break-spaces;
    }
}

@media only screen and (min-width: 960px) {
    .v-col>.v-label {
        font-weight: 700;
        font-size: 14px;
        white-space: break-spaces;
    }
}



.shop-description-input textarea,
.shop-info-container .v-field__input {
    font-size: 14px !important;
    font-weight: 300 !important;
}

.emoji-picker-container {
    width: 300px;
    /* Adjust width as needed */
    height: 400px;
    /* Adjust height as needed */
    overflow-y: auto;
    /* Add scroll if content overflows */
    padding: 8px;
}
</style>
